import { LoginFormProps } from '../../../types';
import './login-form.css';

function LoginForm( props: LoginFormProps) {
    return (
        <form id="login-form" action={props.action} method={props.method}>
            {props.children}
        </form>
    );
}

export default LoginForm;